import { createAction } from 'typesafe-actions';
import { ThemeState } from './types';

export const switchTheme = createAction('theme/SWITCH_THEME')<
  ThemeState['current']
>();
